import { apiClient } from './client'
import type { Tag, TagSearchResult } from '../types'

export const tagsApi = {
  getTags: async (): Promise<Tag[]> => {
    const response = await apiClient.get('/tags')
    return response.data
  },

  createTag: async (name: string): Promise<Tag> => {
    const response = await apiClient.post('/tags', { name })
    return response.data
  },

  searchTags: async (query: string, limit = 10): Promise<TagSearchResult[]> => {
    const response = await apiClient.post('/tags/search', {
      query,
      limit,
    })
    return response.data
  },

  fuzzySearchTags: async (query: string, threshold = 0.6): Promise<Tag[]> => {
    const response = await apiClient.post('/tags/fuzzy', {
      query,
      threshold,
    })
    return response.data
  },
}
